import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

import { BinaryFileDataOut, Client } from '../../../api/api-reference';
import { FileService } from '../../../services/file.service';

@Component({
  selector: 'app-meter-setup-desktop-app',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './meter-setup-desktop-app.component.html',
  styleUrl: './meter-setup-desktop-app.component.scss',
})
export class MeterSetupDesktopAppComponent implements OnInit {
  files: BinaryFileDataOut[] = [];
  loading = false;
  readonly features = [
    'METER_SETUP_DESKTOP_APP_FEATURE_CONNECT',
    'METER_SETUP_DESKTOP_APP_FEATURE_READ_WRITE',
    'METER_SETUP_DESKTOP_APP_FEATURE_IMPORT_EXPORT',
    'METER_SETUP_DESKTOP_APP_FEATURE_FIRMWARE',
    'METER_SETUP_DESKTOP_APP_FEATURE_OFFLINE',
  ];

  constructor(
    private client: Client,
    private fileService: FileService,
    private toastr: ToastrService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.client.listDesktopAppBinaries().subscribe({
      next: (response) => {
        // newest first, so the first card is the latest release
        this.files = [...response].sort(
          (a, b) =>
            new Date(b.lastModified ?? 0).getTime() -
            new Date(a.lastModified ?? 0).getTime(),
        );
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.toastr.error(
          this.translate.instant('METER_SETUP_DESKTOP_APP_LOAD_FAILED'),
        );
      },
    });
  }

  downloadLatest(): void {
    this.client.downloadLatestDesktopAppBinary().subscribe({
      next: (response) => {
        // the latest is the first card, whose name is the one shown next to the button
        this.fileService.downloadFile(response.data, response.fileName || this.files[0]?.fileName || '');
      },
      error: () => {
        this.toastr.error(
          this.translate.instant('METER_SETUP_DESKTOP_APP_DOWNLOAD_FAILED'),
        );
      },
    });
  }

  download(file: BinaryFileDataOut): void {
    this.client.downloadDesktopAppBinary(file.fileName).subscribe({
      next: (response) => {
        this.fileService.downloadFile(response.data, response.fileName || file.fileName);
      },
      error: () => {
        this.toastr.error(
          this.translate.instant('METER_SETUP_DESKTOP_APP_DOWNLOAD_FAILED'),
        );
      },
    });
  }

  formatSize(bytes: number): string {
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }
}
